/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades';
import IDivisionesTiposPropiedades from 'Infotrack@Modelos/smartStock/divisionesTiposPropiedades/entidades/divisionesTiposPropiedades';

export default class ControladorModeloDivisionesTiposPropiedades {
    private modeloDivisionesTiposPropiedades: ModeloDivisionesTiposPropiedades;
    constructor() {
        this.modeloDivisionesTiposPropiedades = new ModeloDivisionesTiposPropiedades();
    }

    public consultarDivisionesTiposPropiedades() {
        return this.modeloDivisionesTiposPropiedades
            .consultarDivisionesTiposPropiedades()
            .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        await this.modeloDivisionesTiposPropiedades.crearDivisionesTiposPropiedades(divisionesTiposPropiedades);
    }

    public async editarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        await this.modeloDivisionesTiposPropiedades.editarDivisionesTiposPropiedades(divisionesTiposPropiedades);
    }
    public async eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        await this.modeloDivisionesTiposPropiedades.eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades);
    }

    public validarEntidad(divisionesTiposPropiedades: IDivisionesTiposPropiedades): boolean {
        if (
            divisionesTiposPropiedades.DivisionTipoPropiedadDescripcion === '' ||
            divisionesTiposPropiedades.Propiedad === ''
        ) {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarDivisionesTiposPropiedadesPorFiltro(divisionesTiposPropiedades: Partial<IDivisionesTiposPropiedades>) {
        return (await this.modeloDivisionesTiposPropiedades.consultarPorFiltroDivisionesTiposPropiedades(divisionesTiposPropiedades)).data.Entidades;
    }

}
